import { isMirnNotFound, isNMIHardStop, isNMIServiceable } from '@origin-digital/sales-common';

import { TNMIAddress } from './types';

export const maskNMI = (nmi: string): string | null => {
  return nmi.trim().length ? `${nmi.slice(0, 2)}****${nmi.slice(6)}*` : null;
};

export const isAllAddressesNMIHardStop = (addresses?: TNMIAddress[]): boolean => {
  return addresses?.length ? addresses.every((addr) => isNMIHardStop(addr.nmiStatus)) : false;
};

export const isAllAddressesNMIServiceable = (addresses?: TNMIAddress[]): boolean => {
  return addresses?.length ? addresses.every((addr) => isNMIServiceable(addr.nmiStatus)) : false;
};

export const isAllAddressesMirnNotFound = (addresses?: TNMIAddress[]): boolean => {
  return addresses?.length ? addresses.every((addr) => isMirnNotFound(addr.mirnStatus)) : false;
};

export const isRequiredToConfirmAddress = (addresses?: TNMIAddress[]): boolean => {
  return !!addresses?.length && !isAllAddressesNMIHardStop(addresses);
};

export const isExactMatchForNMI = (addresses?: TNMIAddress[]): boolean => {
  return addresses?.length === 1 && !!addresses[0].isExactMatchForNMI;
};
